import { create } from 'zustand';

interface UnreadCountState {
  readonly unreadCount: number;
}

const useUnreadCountStore = create<UnreadCountState>(() => ({
  unreadCount: 0,
}));

export const useUnreadCount = (): number => useUnreadCountStore((state) => state.unreadCount);
export const setUnreadCount = (unreadCount: number): void => useUnreadCountStore.setState({ unreadCount });
